<template>
	<div style="height: 100%; width: 100%;" class="content-pad-vert">
		<div class="nav-container">
			<div class="parallelogramlogo">
				<div class="unskew">
					<div class="d-inline-block">
						<img style="cursor: pointer" @click="saveAndExit" src="/static/images/navbar/logo-color.svg" height="35" alt="WRKPRTY" />
					</div>
					<div class="ml-4 d-inline-block text-xs-center" v-if="!userIsHost">
						<h4 class="ma-0">Step 2</h4>
						<p>Location Info</p>
					</div>
					<div class="ml-4 d-inline-block text-xs-center" v-else>
						<h4 class="ma-0">Hosting</h4>
						<p>Add New Location</p>
					</div>
				</div>
			</div>
			<div class="parallelogram hidden-xs-only" v-if="!userIsHost">
				<div class="unskew">
					<div class="text-xs-center">
						<h4 class="white--text ma-0">Step 3</h4>
						<p class="white--text">Post your wrkprty!</p>
					</div>
				</div>
			</div>
			<div class="d-inline-block pa-3" style="float: right">
				<h4 class="hidden-xs-only">
					<v-btn @click="help" flat small class="pa-1" style="min-width: auto">Help</v-btn>|<v-btn @click="saveAndExit" flat small class="pa-1">Save &amp; Exit</v-btn>
				</h4>
				<v-menu bottom offset-y>
					<v-btn slot="activator" icon>
						<v-icon>
							menu
						</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile v-for="(item, i) in menuItems" :key="i" @click="item.scr">
							<v-list-tile-title>{{ item.title }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</div>
		</div>
		
		<v-container fluid class="ma-0 pa-0">
			<v-layout row wrap>
				<v-flex sm4 md3 hidden-xs-only class="pa-4 pt-5">
					<div class="add-event-progress-border pt-3 pb-5">
						<div v-for="(step, index) in steps" class="mb-3 pl-4" :key="index">
							<div v-if="index === 0" @click="routeToLink(step.link)" :class="isSelected(step.link)">
								<h2 class="mb-2">{{ step.title }}</h2>
							</div>
							<div v-else-if="index < steps.length-1" @click="routeToLink(step.link)" :class="isSelected(step.link)">
								<div style="display: inline-block; width: 35px;">
									<v-icon style="color: #25e684; font-size: 1.28em;" v-if="stepIsValid(step.link)">fal fa-check</v-icon>
									<v-icon class="add-event-step-icon-invalid" style="font-size: 1.28em;" v-else-if="stepIsInvalid(step.link)">fal fa-exclamation-circle</v-icon>
									<v-icon style="font-size: 1.28em;" v-else>fal fa-circle</v-icon>
								</div>
								<div style="display: inline-block">
									{{ step.title }}
								</div>
							</div>
							<div v-else @click="routeToLink(step.link)" :class="[isSelected(step.link), 'mt-4']">
								<div style="display: inline-block; width: 35px;">
									<v-icon style="color: #25e684; font-size: 1.28em;" v-if="getAddLocationProp('validSteps').length >= steps.length - 1">fal fa-check</v-icon>
									<v-icon style="font-size: 1.28em" v-else-if="!visitedSubmit">fal fa-lock</v-icon>
									<v-icon style="font-size: 1.28em" v-else>fal fa-circle</v-icon>
								</div>
								<div style="display: inline-block">
									{{ step.title }}
								</div>
							</div>
						</div>
					</div>
				</v-flex>
				<v-flex xs12 sm8 md9 class="pl-4 pr-4 pb-5" style="padding-top: 80px!important">
					<router-view></router-view>
					<div class="hidden-xs-only text-xs-center" style="width: 50%">
						<v-btn
							v-if="getStep.link === steps[0].link"
							@click="goToNextStep"
							class="btn-min-height btn-blue btn-large elevation-2"
							style="width: 200px;"
						>
							Continue
						</v-btn>
						<v-btn
							v-else-if="getStep.link !== steps[steps.length-1].link"
							@click="goToNextStep" 
							class="btn-min-height btn-blue btn-large elevation-2"
							style="width: 250px;"
						>
							Save and Continue
						</v-btn>
						<div v-else>
							<v-btn
								v-if="!userIsHost"
								@click="submit('/host/progress?host-application=submitted')"
								class="btn-min-height btn-blue btn-large elevation-2"
								:disabled="!getAddLocationReadyToSubmit || !getAddLocationProp('confirmLocationUse')"
								style="width: 250px;"
								:loading="submitting"
							>
								Submit and continue
							</v-btn>
							<div v-else>
								<v-btn 
									@click="submit('/host/dashboard/')"
									class="btn-min-height btn btn-blue btn-large elevation-2"
									:disabled="!getAddLocationReadyToSubmit || !getAddLocationProp('confirmLocationUse')"
									style="width: 200px;"
									:loading="submitting"
								>
									Submit
								</v-btn>
								<v-btn 
									@click="submit('/host/add/event/location')"
									class="btn-min-height btn-blue btn-large elevation-2"
									:disabled="!getAddLocationReadyToSubmit || !getAddLocationProp('confirmLocationUse')"
									style="width: 300px;"
									:loading="submitting"
								>
									Submit and create event
								</v-btn>
							</div>
						</div>
					</div>
				</v-flex>
			</v-layout>
			<v-btn small fab bottom right fixed class="btn-yellow add-event-mobile-info-button hidden-md-and-up" v-if="!hostProcessModal" @click="hostProcessModal=true"><img src="/static/images/icon/light-bulb-gray.svg" width="30" /></v-btn>

			<v-card v-if="!hostProcessModal" class="add-event-mobile-bottom-nav pa-0 hidden-sm-and-up">
				<v-card-actions class="pa-0">
					<v-btn large flat v-if="((getStep.link !== steps[0].link) && !visitedSubmit)" class="ma-0 add-event-mobile-bottom-nav-back" @click="goToPreviousStep()" :disabled="getStep === steps[0]">Back</v-btn><v-btn v-if="getStep.link === steps[0].link" large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-begin" @click="goToNextStep">Begin</v-btn><v-btn large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-begin" v-else-if="(visitedSubmit === true && getStep.link !== steps[steps.length-1].link)" @click="routeTo('/host/add/location/submit/')">Return to Review</v-btn><v-btn v-else-if="getStep.link !== steps[steps.length-1].link" large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-next" @click="goToNextStep()">Next</v-btn><v-btn v-else-if="!userIsHost" large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-begin" @click="submit('/host/dashboard/?host-application=submitted')" :disabled="!getAddLocationReadyToSubmit || !getAddLocationProp('confirmLocationUse')"><span v-if="getAddLocationReadyToSubmit && getAddLocationProp('confirmLocationUse')" :loading="submitting">Submit</span><span v-else-if="!getAddLocationReadyToSubmit" class="add-event-step-invalid">Fix Errors</span><span v-else class="add-event-step-invalid">Confirm Location Use Terms</span></v-btn><v-btn v-else large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-begin" @click="submit('/')" :disabled="!getAddLocationReadyToSubmit || !getAddLocationProp('confirmLocationUse')"><span v-if="getAddLocationReadyToSubmit && getAddLocationProp('confirmLocationUse')" :loading="submitting">Submit</span><span v-else-if="!getAddLocationReadyToSubmit" class="add-event-step-invalid">Fix Errors</span><span v-else class="add-event-step-invalid">Confirm Location Use Terms</span></v-btn>
				</v-card-actions>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { fetchEventTags } from '~/store/api/event_location_api'
import axios from 'axios'

export default {
	data() {
		return {
			submitting: false,
			submitAttempt: false,
			foo: 'asdf',
			currentStepPath: window.location.pathname,
			menuItems: [
				{
					title: 'Help',
					scr: this.help
				},
				{
					title: 'Save & Exit',
					scr: this.saveAndExit
				}
			],
			steps: [
				{ title: 'Add Location', link: '/host/add/location' },
				{ title: 'Address', link: '/host/add/location/location' },
				{ title: 'Type of Venue', link: '/host/add/location/type' },
				{ title: 'Seating / Capacity', link: '/host/add/location/seating' },
				{ title: 'Amenities', link: '/host/add/location/amenities' },
				{
					title: 'Description & Rules',
					link: '/host/add/location/description'
				},
				{ title: 'Photos', link: '/host/add/location/photos' },
				{ title: 'Review & Submit', link: '/host/add/location/submit' }
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		let currentPage = this.$router.currentRoute.path
		let startPage = this.steps[0].link
		let locationPage = this.steps[1].link
		let submitPage = this.steps[this.steps.length - 1].link
		if (
			(locationPage === currentPage || locationPage + '/' === currentPage) &&
			this.getAddLocationProp('partialLocationPk') === null
		) {
			this.startPartialLocation()
		} else if (
			startPage !== currentPage &&
			startPage + '/' !== currentPage &&
			submitPage !== currentPage &&
			submitPage + '/' !== currentPage
		) {
			console.log('update')
			this.updatePartialLocation()
		}
		next()
	},
	created() {
		this.setlastHostApplyStep(this.$route.name)
	},
	methods: {
		...mapActions([
			'setHostHelpOpen',
			'fetchAllLocations',
			'setlastHostApplyStep',
			'serverPostLocation',
			'setAddLocationProp',
			'addLocationResetState',
			'setGenericModalText',
			'setGenericModalTitle',
			'addEventResetState',
			'setModalOpen',
			'setModalProp',
			'addLocation',
			'deletePartialLocation',
			'startPartialLocation',
			'updatePartialLocation'
		]),
		help() {
			this.setModalOpen({ prop: 'hostProcessModal', value: true })
			this.setModalProp({
				prop: 'hostProcessModalPage',
				value: 'host_add_event_intro'
			})
		},
		saveAndExit() {
			this.$router.push({ name: 'host_dashboard' })
		},
		goToNextStep() {
			let currentPage = this.$router.currentRoute.path
			for (var i = 0; i < this.steps.length; i++) {
				let linkPage = this.steps[i].link
				if (linkPage === currentPage || linkPage + '/' === currentPage) {
					this.routeTo(this.steps[i + 1].link)
					return
				}
			}
			this.routeTo(this.steps[0].link)
		},
		goToPreviousStep() {
			let currentPage = this.$router.currentRoute.path
			for (var i = 0; i < this.steps.length; i++) {
				let linkPage = this.steps[i].link
				if (linkPage === currentPage || linkPage + '/' === currentPage) {
					if (i - 1 > 0) {
						this.routeTo(this.steps[i - 1].link)
						return
					}
				}
			}
			this.routeTo(this.steps[0].link)
		},
		begin() {
			this.routeTo(this.steps[0].link)
		},
		routeTo(url) {
			let currentPage = this.$router.currentRoute.path
			let startPage = this.steps[0].link
			let locationPage = this.steps[1].link
			if (
				(locationPage === currentPage || locationPage + '/' === currentPage) &&
				this.getAddLocationProp('partialLocationPk') === null
			) {
				this.startPartialLocation()
			} else if (startPage !== currentPage && startPage + '/' !== currentPage) {
				this.updatePartialLocation()
			}
			this.$router.push(url)
		},
		routeToLink(url) {
			if (url === '/host/add/location/submit') {
				if (
					this.getAddLocationProp('validSteps').length >=
						this.steps.length - 1 ||
					this.visitedSubmit
				) {
					this.routeTo(url)
				}
			} else {
				this.routeTo(url)
			}
		},
		isSelected(link) {
			let wPath = window.location.pathname
			let windowPath =
				wPath.substr(wPath.length - 1) === '/' ? wPath.slice(0, -1) : wPath
			if (link === windowPath) {
				return 'add-event-step-link-selected'
			} else {
				return 'add-event-step-link'
			}
		},
		submit(nextURL) {
			this.submitting = true
			let formData = new FormData()

			let primaryImage = this.getAddLocationProp('primaryImage')
			let additionalImages = this.getAddLocationProp('images').slice(0)

			if (additionalImages !== []) {
				let primaryIndex = additionalImages.indexOf(primaryImage)
				additionalImages.splice(primaryIndex, 1)
			}

			formData.append('owner', this.user.pk)
			formData.append('location_type', this.getAddLocationProp('type'))
			formData.append('max_attendees', this.getAddLocationProp('seats'))

			formData.append('name', this.getAddLocationProp('title'))
			formData.append('description', this.getAddLocationProp('description'))
			formData.append('location_rules', this.getAddLocationProp('rules'))

			let privateAddress = this.getAddLocationProp('privateAddress')
			let address = Object.assign({}, this.getAddLocationProp('address'))
			if (this.getAddLocationProp('apartmentCheck')) {
				privateAddress += ' # ' + this.getAddLocationProp('apartmentNumber')
				address.apartment_number = this.getAddLocationProp('apartmentNumber')
			}
			formData.append('address', JSON.stringify(address))

			formData.append('private_address', privateAddress)
			formData.append(
				'public_address',
				this.getAddLocationProp('publicAddress')
			)
			formData.append(
				'provisions',
				JSON.stringify({
					provisions: this.getAddLocationProp('locationInfo'),
					inputs: this.getAddLocationProp('locationInfoInputs')
				})
			)

			formData.append('primary_image', primaryImage)

			for (var e = 0; e < additionalImages.length; e++) {
				formData.append('additional_images', additionalImages[e])
			}
			// actual accurate coordinates
			formData.append('private_latitude', this.getAddLocationProp('latitude'))
			formData.append('private_longitude', this.getAddLocationProp('longitude'))

			formData.append('parking_info', '')

			axios({
				method: 'post',
				url: '/api/v1/location/',
				data: formData
			})
				.then(response => {
					if (nextURL === '/host/add/event/location') {
						nextURL += '?location=' + response.data.pk
						this.addEventResetState()
					}
					// let mapImageData = {'center': '123,456', 'location': response.data.pk}
					// // create map image on separate api call
					// axios({
					// 	method: 'post',
					// 	url: '/api/v1/map_image/',
					// 	data: mapImageData
					// }).then((response) => {
					// 	console.log(response)
					// })
					this.deletePartialLocation(
						this.getAddLocationProp('partialLocationPk')
					)
					this.addLocation(response.data)
					this.addLocationResetState()
					this.$router.push(nextURL)
				})
				.catch(error => {
					this.submitting = false
					console.log('axios error')
					console.log(error)
					this.setModalOpen({ prop: 'genericModal', value: true })
					this.setGenericModalTitle('Error')
					let errors = ['ERROR Invalid Location']
					if (error.response) {
						if (typeof error.response.data !== 'string') {
							for (var prop in error.response.data) {
								if (error.response.data.hasOwnProperty(prop)) {
									errors.push(prop + ': ' + error.response.data[prop])
								}
							}
						} else {
							errors.push(error.response.data)
						}
					}
					this.setGenericModalText(errors)
				})
		},
		stepIsValid(stepLink) {
			return (
				this.getAddLocationProp('validSteps').includes(stepLink) ||
				this.getAddLocationProp('validSteps').includes(stepLink + '/')
			)
		},
		stepIsInvalid(stepLink) {
			return (
				this.getAddLocationProp('invalidSteps').includes(stepLink) ||
				this.getAddLocationProp('invalidSteps').includes(stepLink + '/') ||
				(!(
					this.getAddLocationProp('validSteps').includes(stepLink) ||
					this.getAddLocationProp('validSteps').includes(stepLink + '/')
				) &&
					this.submitAttempt)
			)
		}
	},
	watch: {
		$route(to, from) {
			this.submitting = false
			this.setlastHostApplyStep(to.name)
			let val = to.path
			this.currentStepPath = val
		}
	},
	computed: {
		...mapGetters([
			'user',
			'userIsHost',
			'getEventTags',
			'getAddLocationProp',
			'getAddLocationReadyToSubmit',
			'getModalProp'
		]),
		getStep() {
			// let ar = this.$router.currentRoute.path.split('/')
			// while (ar[ar.length - 1] === '' && ar.length > 0) {
			// 	ar.pop()
			// }
			// let currentPage = ar[ar.length - 1]
			for (var i = 0; i < this.steps.length; i++) {
				// ar = this.steps[i].link.split('/')
				// let linkPage = ar[ar.length - 1]
				if (
					this.steps[i].link === this.currentStepPath ||
					this.steps[i].link + '/' === this.currentStepPath
				) {
					return this.steps[i]
				}
			}
			return this.steps[0]
		},
		getCurrentPage() {
			return this.$router.currentRoute.path.slice(0, -1)
			// return window.location.pathname.slice(0, -1)
		},
		curentStepNum() {
			return this.steps.indexOf(this.getStep) + 1
		},
		hostProcessModal: {
			get() {
				return this.getModalProp('hostProcessModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'hostProcessModal', value: val })
				this.setModalProp({
					prop: 'hostProcessModalPage',
					value: this.$router.currentRoute.name
				})
			}
		},
		visitedSubmit() {
			return this.getAddLocationProp('visitedSubmit')
		}
	}
}
</script>

<style lang="scss">
.submit-btn {
	background-color: #74cbf1 !important;
}
.mobile-submit-btn {
	background: white;
	z-index: 1;
	padding: 0px;
	position: fixed;
	width: 100%;
	bottom: 0px;
	left: 0;
	right: 0;
	.btn {
		margin: 0;
		padding: 0px;
		width: 100%;
		opacity: 1;
	}
}
</style>
